import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CenteredScrollableContent } from './component/centered-scrollable-content.component';


@NgModule({
  declarations: [
    CenteredScrollableContent
  ],
  exports: [
    CenteredScrollableContent
  ],
  imports: [
    CommonModule
  ]
})
export class CenteredScrollableContentModule { }
